import axios from "axios";
import appConfig from "../config/appConfig";
import { verifyPermission } from "../helpers/permission";


export const createEndpoints = (plan, userPermissions) => {
  const endpoints = {
    PRO: {
      list: (page = 1, perPage = 10, search = '')  => `${appConfig.apiDomaine}/my/users?page=${page}&size=${perPage}&search_text=${search}`,
      enableDisable: (userId) => `${appConfig.apiDomaine}/my/users/${userId}/enabled-desabled`,
      logout: `${appConfig.apiDomaine}/logout`,
    },
    MACRO: {
      holding: {
        staffCreate: `${appConfig.apiDomaine}/any/staff/create`,
        list: (page = 1, perPage = 10, search = '', entity)  => `${appConfig.apiDomaine}/any/users?${entity !== null ? `${entity.key}=${entity.value}&` : ''}page=${page}&size=${perPage}&search_text=${search}`,
        enableDisable: (userId) => `${appConfig.apiDomaine}/any/users/${userId}/enabled-desabled`,
        downloadPdf: (entity) => `${appConfig.apiDomaine}/any/users/download/pdf${entity !== null ? `?${entity.key}=${entity.value}` : ''}`,
        downloadExcel: (entity) => `${appConfig.apiDomaine}/any/users/download/excel${entity !== null ? `?${entity.key}=${entity.value}` : ''}`,
        logout: `${appConfig.apiDomaine}/logout`,
      },
      filial: {
        staffCreate: `${appConfig.apiDomaine}/my/staff/create`,
        list: (page = 1, perPage = 10, search = '', entity) => `${appConfig.apiDomaine}/my/users?${entity != null ? `${entity?.key}=${entity.value}&` : ''}page=${page}&size=${perPage}&search_text=${search}`,
        enableDisable: (userId) => `${appConfig.apiDomaine}/my/users/${userId}/enabled-desabled`,
        downloadPdf: (entity) => `${appConfig.apiDomaine}/my/users/download/pdf${entity !== null ? `?${entity.key}=${entity.value}` : ''}`,
        downloadExcel: (entity) => `${appConfig.apiDomaine}/my/users/download/excel${entity !== null ? `?${entity.key}=${entity.value}` : ''}`,
        logout: `${appConfig.apiDomaine}/logout`,
      },
    },
    HUB: {
      list: (page = 1, perPage = 10, search = '')  => `${appConfig.apiDomaine}/any/users?page=${page}&size=${perPage}&search_text=${search}`,
      enableDisable: (userId) => `${appConfig.apiDomaine}/any/users/${userId}/enabled-desabled`,
      logout: `${appConfig.apiDomaine}/logout`,
    },
  };

  let endPoint = '';
  switch(plan){
    case 'MACRO':
        if(verifyPermission(userPermissions,'list-any-unit'))
            endPoint = endpoints[plan].holding;
        if(verifyPermission(userPermissions,'list-my-unit'))
            endPoint = endpoints[plan].filial;
        break;
    default:
        endPoint = endpoints[plan];
        break;
  }
  return endPoint;
};

export const fetchUsers = async (endPoint, page, perPage = 10, search = '', entity) => {
  try {
    const response = await axios.get(endPoint.list(page,perPage,search,entity));
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enableDisableUser = async (endPoint, userId) => {
  try {
    const response = await axios.put(endPoint.enableDisable(userId));
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logoutUser = async (endPoint, userId) => {
    try {
        const response = await axios.post(endPoint.logout, { id:userId });
        return response.data;
    } catch (error) {
        throw error;
    }
}
